import React from 'react';
import PropTypes from 'prop-types';

const ListElement = props => (
  <div className={`eva-3-row -no-gutter ${props.valign && '-eva-3-valign'}`}>
    <div className="col">
      <span>
        {
          props.order
          ? <div>{props.order}.</div>
            : <div className={props.className}>•</div>
        }
      </span>
    </div>
    <div className="col -sm-11 -eva-3-ml-xsm">
      {props.children}
    </div>
  </div>
);

ListElement.defaultProps = {
  order: undefined,
  className: undefined,
  valign: undefined,
};

ListElement.propTypes = {
  order: PropTypes.string,
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  valign: PropTypes.string,
};

export default ListElement;
